import getUrl from "@utils/getUrl";

const SESSION_KEY = "__reshop_session";

export function clearSessionFromStorage() {
  localStorage.removeItem(SESSION_KEY);
}

export function getSessionFromStorage() {
  return localStorage.getItem(SESSION_KEY);
}

export function saveSessionToStorage(session: string): void {
  const currentSession = getSessionFromStorage();

  if (session !== currentSession) {
    localStorage.setItem(SESSION_KEY, session);
  }
}

function saveSessionFromResponse(response: Response): void {
  const sessionHeader = response.headers.get("x-set-reshop-session-state");
  if (sessionHeader && sessionHeader.trim() !== "") {
    localStorage.setItem(SESSION_KEY, sessionHeader);
  }
}

export function setupFetchInterception(): void {
  const originalFetch = window.fetch;
  window.fetch = async function (
    input: RequestInfo | URL,
    init: RequestInit = {},
  ): Promise<Response> {
    const url = getUrl(input);
    const session = getSessionFromStorage();

    if (session && url.origin === window.location.origin) {
      const headers = new Headers(init.headers);
      headers.set("x-reshop-session-state", session);
      init.headers = headers;
    }
    const response = await originalFetch(input, init);
    saveSessionFromResponse(response);
    return response;
  };
}
